import { fieldNames } from '../../shared/configs/acceptanceForm';
import { evenOddDays } from '../../shared/configs/selectionData/days';
import { evenOddDayIds } from '../../shared/configs/selectionData/scheduleTypes';
import {
  mapDeskDateRanges,
  mapDeskDateRangesToForm,
} from './mapDeskDateRanges';
import {
  createMapDeskScheduleSettingsToForm,
  createMapDesksScheduleSettings,
} from './mapDeskScheduleSetting';
import { mapToPayload } from './mapToPayload';
import { asIs, extractKeyFromLabel } from './methods';

const {
  name: deskName,
  uniqueDateRange: uniqueDateRangeName,
  dateRanges: dateRangesName,
  workingDays: workingDaysName,
  scheduleType: scheduleTypeName,
  intervalType: intervalTypeName,
  isHoliday: isHolidayName,
  scheduleSettings: scheduleSettingsName,
  isCommonSchedules: isCommonSchedulesName,
} = fieldNames.desk;

export const mapDesks = (desks, isDraft) => {
  return desks.map((desk) => {
    return mapToPayload(
      desk,
      createToPayloadMapper({
        isCommonSettings: desk[isCommonSchedulesName],
        days: getDays(desk),
      }),
      isDraft
    );
  });
};

export const createMapDesksToForm = ({ desksMap, timeIntervals }) => {
  const mapToForm = (desks) => {
    return desks.map((desk) => {
      return mapToPayload(
        desk,
        createToFormMapper({
          desksMap,
          timeIntervals,
          intervalType: desk[intervalTypeName],
          isCommonSchedules: desk[isCommonSchedulesName],
        })
      );
    });
  };

  return mapToForm;
};

function createToFormMapper({
  desksMap,
  timeIntervals,
  intervalType,
  isCommonSchedules,
}) {
  return {
    [deskName]: createDeskNameValueGetter(desksMap),
    [isCommonSchedulesName]: (value) =>
      typeof value === 'boolean' ? value : false,
    [uniqueDateRangeName]: asIs,
    [workingDaysName]: asIs,
    [isHolidayName]: asIs,
    [scheduleTypeName]: asIs,
    [intervalTypeName]: asIs,
    [dateRangesName]: mapDeskDateRangesToForm,
    [scheduleSettingsName]: createMapDeskScheduleSettingsToForm({
      timeIntervals,
      intervalType,
      isCommonSchedules,
    }),
  };
}

function getDays(desk) {
  const { [scheduleTypeName]: scheduleType, [workingDaysName]: days } = desk;

  return evenOddDayIds.has(scheduleType) ? [...evenOddDays.keys()] : days;
}

function createToPayloadMapper({ isCommonSettings, days }) {
  return {
    [deskName]: extractKeyFromLabel,
    [uniqueDateRangeName]: asIs,
    [dateRangesName]: mapDeskDateRanges,
    [workingDaysName]: asIs,
    [scheduleTypeName]: asIs,
    [intervalTypeName]: asIs,
    [isHolidayName]: asIs,
    [isCommonSchedulesName]: asIs,
    [scheduleSettingsName]: createMapDesksScheduleSettings({
      isCommonSettings,
      days,
    }),
  };
}

function createDeskNameValueGetter(desksMap) {
  return (id) => {
    return { key: id, label: desksMap.get(id)?.name ?? '' };
  };
}
